"use strict";

/**
 * @classdesc
 * Klappt einen Layer auf, wenn er zu ist bzw. umgekehrt.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.layer.GCAbstractLayer} options.layer Auf-/zuzuklappender Layer
 */
gc.gis.action.layer.ToggleExpansion = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doToggle;
	/**
	 * @inheritdoc
	 */
	this.args = [options.layer];
};
gc.gis.action.layer.ToggleExpansion.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Klappt einen Layer auf, wenn er zu ist bzw. umgekehrt.
 *
 * @public
 * @param {gc.gis.layer.GCAbstractLayer} layer Auf-/zuzuklappender Layer
 */
gc.gis.action.layer.ToggleExpansion.prototype.doToggle = function( layer )
{
	if (layer instanceof gc.gis.layer.GCGroupLayer
		|| (layer instanceof gc.gis.layer.GCLayer && layer.getShowLegend()))
	{
		layer.setExpanded( !layer.isExpanded() );
	}
};

